import React from "react";
import CardDisplay from "./../molecules/CardDisplay";
import Navbar from "./../molecules/Navbar";
import { useState } from "react";
import Filters from "./../molecules/Filters";
import TextField from "@mui/material/TextField";
import SearchIcon from "@mui/icons-material/Search";
import Button from "@mui/material/Button";
import "../molecules/Navbar.css";
export default function LandingPage(props) {
  const [genreFilters, setGenreFilters] = useState({
    "All Genre": true,
    Education: false,
    Sports: false,
    Comedy: false,
    Lifestyle: false,
  });
  const [ageFilters, setAgeFilters] = useState({
    "Any age group": true,
    "7+": false,
    "12+": false,
    "16+": false,
    "18+": false,
  });
  const [search, setSearch] = useState("");
  const [sortBy, setSortBy] = useState();
  const genreFiltersApplied = (genreFilters) => {
    setGenreFilters(genreFilters);
  };
  const ageFiltersApplied = (ageFilters) => {
    setAgeFilters(ageFilters);
  };
  const sortByFn = (sortBy) => {
    setSortBy(sortBy);
  };
  const handleSearch = (searchedVideo) => {
    setSearch(searchedVideo);
  };

  return (
    <div>
      <Navbar children={true} search={search} handleSearch={handleSearch} />

      <div
        style={{
          display: "flex",
        }}
        id="search-input"
      >
        <TextField
          sx={{
            width: "85%",
            maxWidth: "100%",
            borderRadius: "none",

            // border: "1px solid #606060",
          }}
          className="search-mobile"
          fullWidth
          id="outlined-size-small"
          placeholder="Search"
          size="small"
          value={search}
          onChange={(e) => {
            handleSearch(e.target.value);
          }}
        />

        <Button
          className="search-mobile btn-mobile"
          style={{
            backgroundColor: "#444D56",
            border: "1px solid #606060",
            width: "15%",
            color: "white",
            paddingRight: "2px",
          }}
          variant="contained"
          startIcon={<SearchIcon />}
        ></Button>
      </div>
      <Filters
        className="filtersMargin"
        genreFilters={genreFilters}
        ageFilters={ageFilters}
        sortBy={sortBy}
        genreFiltersApplied={genreFiltersApplied}
        ageFiltersApplied={ageFiltersApplied}
        checkSortBy={sortByFn}
        isSearched={search}
      />
      <CardDisplay
        ageFilters={ageFilters}
        genreFilters={genreFilters}
        sortBy={sortBy}
        search={search}
      />
    </div>
  );
}
